import bus from '@/utils/eventBus'

export default function () {
  this.getStaffCompany()

  window.$(this.$el).on('shown.bs.modal', () => {
    document.getElementById('document').value = ''
    document.getElementById('name').value = ''
    document.getElementById('email').value = ''
    this.$emit('toggle', true)
  })

  window.$(this.$el).on('hidden.bs.modal', () => {
    this.$emit('toggle', false)
    this.$emit('close')
  })
  // Se resultado da nusc for null para professional entao ativa o
  // buttom para cadastro de um novo staff
  bus.$on('event-new-staff', values => {
    this.showButtonNewStaff = values.show
  })

  // Especialidades do professional para modo de alteração
  if (this.$route.params.professional) {
    this.existsRegister('/v1/professional/companies/staffs/' + this.$route.params.professional + '/active-specialities', (response, meta) => {
      const optionsProfessionalSpecialitiesArray = Object.keys(response).map(i => response[i])
      this.optionsProfessionalSpecialities = optionsProfessionalSpecialitiesArray
    })
  }

  this.existsRegister('/v1/professional/steps/staff/status', (data, meta) => {
    if (!data.address && !data.covenant) {
      this.statusAddress = data.address
      this.statusCovenant = data.covenant
      this.show = true
    }
    if (data.address && !data.covenant) {
      this.statusAddress = data.address
      this.statusCovenant = data.covenant
      this.show = true
    }
    if (data.address && data.covenant) {
      this.statusAddress = data.address
      this.statusCovenant = data.covenant
      this.show = false
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/form/resources/mounted.js